import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import { fetchUserInfo } from '../../utils';
import Image from '../../components/images/Image';
import Icon from '../../components/common/Icon';
import Back from '../../components/common/Back';
import NotFound from '../../components/common/NotFound';
import { Link } from 'react-router-dom';

const fallbackActivity = require('./../../assets/images/fallback/activity.png');

const Battles = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserInfo('/battles', setUserInfo, setLoading, setError, []);
  }, []);

  const battles = userInfo?.battles || [];

  return (
    <Base activeNav="home">
      <Back to="/home" />
      <Title>
        <Icon name="megaphone" theme="primary" className="me-2" style={{ fontSize: '1.4rem' }} />
        {t('challenges')}
      </Title>

      {battles.length > 0 ? (
        <>
          <div className="battles-grid">
            {battles.map((battle) => (
              <Link
                key={battle.id}
                to="/battle"
                onClick={() => sessionStorage.setItem('selectedBattleId', battle.id)}
                className={`battle-tile ${battle.is_team_joker ? 'battle-tile--joker' : ''}`}
              >
                <div className="battle-tile__media">
                  <Image
                    size="100%"
                    className="battle-tile__image"
                    url={battle.photo_url ? battle.photo_url : fallbackActivity}
                  />
                  <span
                    className={`battle-tile__joker-count ${
                      battle.is_team_joker ? 'battle-tile__joker-count--mine' : ''
                    }`}
                  >
                    <Icon name="star" pack="sr" theme="light" /> {battle.team_count}
                  </span>
                </div>
                <div className="battle-tile__name">{battle.name}</div>
              </Link>
            ))}
          </div>

          <p className="battles-joker-info mx-3 mb-3">
            <Icon name="star" pack="sr" theme="primary" className="me-1" />
            {t('jokerInfo')}
          </p>
        </>
      ) : (
        <NotFound translationKey="noBattlesFound" loading={loading} />
      )}
    </Base>
  );
};

export default Battles;
